// Ссылка на предикт с #yes или #no выбирает исход при загрузке страницы.
// Так баннер btc15m передаёт Up (yes) или Down (no): /request/predictions/btc-live/ отвечает 302
// без query-строки, а фрагмент браузер переносит через редирект сам.
const OUTCOME_HASH = /^#(yes|no)$/i;
const OWN_BLOCKS = '.market-bet--current, .market-bet--current-2, .market-bet--order';

export function outcomeFromHash(hash) {
    const match = OUTCOME_HASH.exec(String(hash ?? ''));
    return match ? match[1].toLowerCase() : null;
}

// Хэш одноразовый: исход читается и убирается из адреса, чтобы после перезагрузки страница вела себя как обычно.
// Любой другой хэш, например #buy или #sell у вкладок, остаётся на месте.
export function consumeOutcomeHash(location, history) {
    const outcome = outcomeFromHash(location.hash);
    if (outcome && history && typeof history.replaceState === 'function') {
        history.replaceState(history.state, '', location.pathname + location.search);
    }
    return outcome;
}

// Первый исход вне позиций и ордеров юзера. Исход из хэша берётся, только если он не закрыт,
// иначе остаётся прежний выбор по умолчанию, yes.
export function pickDefaultBetItem(betItems, preferredTeam) {
    const eligible = [...betItems].filter(item => !item.closest(OWN_BLOCKS));
    const byTeam = team => eligible.find(item => item.getAttribute('data-team') === team);
    const preferred = preferredTeam ? byTeam(preferredTeam) : null;
    if (preferred && !preferred.classList.contains('disabled')) return preferred;
    return byTeam('yes') || null;
}
